export const MOBILE_SIDEBAR_MAX_WIDTH_PX = 768

export const mobileSidebarMediaQuery = `(max-width: ${MOBILE_SIDEBAR_MAX_WIDTH_PX}px)`
